module.exports = __webpack_public_path__ + "media/icons/cross@3x-7a4f2a98.svg";